export default function About() {
  return (
    <>
      {/* HEADER */}
      <section className="about-header">
        <h1>About Cherry Self Drive Cars</h1>
        <p>
          Trusted car rental & travel service providing safe and comfortable
          journeys for families, tourists and business travelers.
        </p>
      </section>

      {/* ABOUT CONTENT */}
      <section className="glass-section about-section">
        <div className="about-grid">
          
          {/* LEFT */}
          <div className="about-text">
            <h2>Who We Are</h2>
            <p>
              Cherry Self Drive Cars is a professional car rental and tour service company
              dedicated to making travel simple, safe and affordable. With
              years of experience in the travel industry, we understand what
              customers need – comfort, reliability and transparency.
            </p>
            <h3>Our Mission</h3>
            <p>
              To provide high-quality travel services with honest pricing,
              excellent customer support and modern vehicles for every type of
              journey.
            </p>

            <h3>Our Vision</h3>
            <p>
              To become the most trusted and preferred car rental service by
              delivering consistent quality, safety and customer satisfaction.
            </p>
          </div>

          {/* RIGHT */}
          <div className="about-highlights">
            <div className="highlight-box hover-rise">
              🚗 <h4>Wide Range of Cars</h4>
              <p>From budget cars to luxury SUVs.</p>
            </div>

            <div className="highlight-box hover-rise">
              👨‍✈️ <h4>Experienced Drivers</h4>
              <p>Polite, trained and route-experienced drivers.</p>
            </div>

            <div className="highlight-box hover-rise">
              💰 <h4>Transparent Pricing</h4>
              <p>No hidden charges, clear pricing.</p>
            </div>

            <div className="highlight-box hover-rise">
              📲 <h4>Easy Booking</h4>
              <p>Quick booking through WhatsApp.</p>
            </div>
          </div>
        </div>
      </section>

      {/* STATS */}
      <section className="about-stats">
        <div className="stat-box">
          <h2>5+</h2>
          <p>Years Experience</p>
        </div>
        <div className="stat-box">
          <h2>390+</h2>
          <p>Happy Customers</p>
        </div>
        <div className="stat-box">
          <h2>10+</h2>
          <p>Cars in Fleet</p>
        </div>
        <div className="stat-box">
          <h2>24/7</h2>
          <p>Customer Support</p>
        </div>
      </section>
    </>
  );
}
